export default "__VITE_ASSET__9ae6275d__"